import React from 'react';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import '../../styles/components/About.css';
import '../../styles/animations.css';

const About = () => {
  const { elementRef, isVisible } = useScrollAnimation();

  return (
    <div className="section">
      <div
        ref={elementRef}
        className={`aboutSection animate-section ${isVisible ? 'visible' : ''}`}
      >
        <h2 className={`about-title animate-element delay-1 ${isVisible ? 'visible' : ''}`}>
          About
        </h2>
        <p className={`about-paragraph animate-element delay-2 ${isVisible ? 'visible' : ''}`}>
          I work on software systems and engineering teams, mainly in fintech and enterprise environments. My experience includes backend development, cloud infrastructure, and close collaboration with product and business teams.

          I focus on building reliable systems, improving engineering practices, and supporting team growth.
        </p>
      </div>
    </div>
  );
};

export default About; 